import { Controller } from "@hotwired/stimulus";

// Swaps a child ui--switch's subtext to describe its *current* setting, rather than explaining both
// positions at once. The switch keeps a fixed title; only the hint below it changes. The switch
// dispatches a bubbling "change" on toggle, which we catch via a data-action on this element.
//
// `hint` shows while the switch is off and `onHint` while it's on. Either may be omitted: with only
// `hint` this behaves as it originally did — a caveat revealed by switching something off. `field` is a
// dependent control that only makes sense while the switch is on (e.g. the approver picker under a
// "Requires approval" switch), so it's hidden while off and revealed while on.
export default class extends Controller {
  static targets = ["hint", "onHint", "field"];

  connect() {
    this.update();
  }

  update() {
    const toggle = this.element.querySelector("[data-controller~='ui--switch']");
    const off = toggle?.dataset.state === "unchecked";
    if (this.hasHintTarget) this.hintTarget.classList.toggle("hidden", !off);
    if (this.hasOnHintTarget) this.onHintTarget.classList.toggle("hidden", off);
    if (this.hasFieldTarget) this.fieldTarget.classList.toggle("hidden", off);
  }
}
